export default __webpack_public_path__ + "static/media/D6.9d45ce8b.png";